<div class="pm-items" [ngClass]="item.class">
    @for (child of item.children; track trackByProp($index, child)) {
        <ng-container *vnDynamicComponent="getItemComponent(child.type); attr: { item: child }" />
    }
</div>
